import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yt-play",
  "use": "icon-yt-play-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yt-play\">\n<path d=\"M0 12.312C0.0276982 13.6161 1.27948 14.4049 2.37571 13.7844L11.1935 8.44611C11.674 8.15586 12 7.62159 12 6.9969C12 6.37221 11.674 5.83795 11.1935 5.54769L2.37571 0.216665C1.27948 -0.40383 0.0276819 0.377573 0 1.68165V12.312Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/yt-play.svg
// module id = 190
// module chunks = 0 1 2